import { Route, Switch } from 'react-router-dom/cjs/react-router-dom.min';

import { ADMINS_ENTITY_NAME_CORRECTIONS_PATH } from '../../utils/constants';
import { EntityNameList } from './components/EntityNameList';
import React from 'react';

export const EntityNameCorrections = () => {
  return (
    <Switch path={ADMINS_ENTITY_NAME_CORRECTIONS_PATH}>
      <Route exact path={ADMINS_ENTITY_NAME_CORRECTIONS_PATH} component={EntityNameList} />
    </Switch>
  );
};
